import React from "react";
import Navbutton from "../navbutton/Navbutton";
import fundofolha from "../image/fundofolha.jpg";
import './Blog.css';
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import Header from "../components/Header";

const ArticlePage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="article-container">
      <Header />

      <header className="article-header">
        <h1 className="article-title">A importância e os riscos do <span>transporte</span> de produtos perigosos</h1>
        <p className="article-date">Publicado em: 17 de Janeiro, 2025</p>
      </header>

      <section className="article-main-content">
        <img
          src={SiYourtraveldottv} // Substitua pelo caminho da imagem
          alt="Transporte de Produtos Perigosos"
          className="article-image"
        />
        <p className="article-paragraph">
          Diariamente nas rodovias do Brasil, circulam milhares de veículos transportando produtos perigosos, nas suas mais variadas formas de armazenamento e estado físico, que são fundamentais para diversas atividades econômicas. Na rota desses produtos, os veículos passam por áreas como cidades, rios, córregos e áreas ambientalmente protegidas.
        </p>
        <p className="article-paragraph">
          Provavelmente você, caro leitor, já observou um veículo com um painel laranja, contendo uma sequência numérica e um outro painel de cores variadas, contendo símbolos. Mas o que isso significa? Esses painéis e rótulos identificam os produtos perigosos e seus riscos!
        </p>
        <p className="article-paragraph">
          Essas sinalizações são padronizadas internacionalmente, com base no sistema da ONU (Organização das Nações Unidas), e são aplicadas em embalagens, veículos e documentos de transporte. A simbologia de risco no transporte de produtos perigosos é essencial para garantir a identificação rápida dos materiais transportados e seus perigos associados.
        </p>
        <p className="article-paragraph">
          Emergências com produtos perigosos representam cenários complexos e dinâmicos, onde cada decisão no início da operação pode determinar o sucesso do controle do evento. É fundamental compreender os riscos associados a esses materiais, bem como adotar procedimentos padronizados para minimizar impactos e proteger vidas.
        </p>
        <p className="article-paragraph">
          Neste contexto, o conhecimento de técnicas dos primeiros passos no atendimento é determinante para uma resposta de forma eficaz, segura e coordenada a incidentes que podem causar riscos à saúde, ao meio ambiente e à segurança pública.
        </p>
        <p className="article-paragraph">
          A Biolink é uma consultoria especializada em Infraestrutura, e desenvolvemos Planos de Gestão de Riscos e Planos de Ação Emergencial (PGR/PAE), que são respectivamente um conjunto de procedimentos que visam prevenir acidentes ambientais, de trabalho e proteger a segurança da população. É um documento que deve conter informações para atuar em caso de acidente. Além disso, a Biolink desenvolve treinamentos, simulados e outras instruções técnicas sobre este assunto, com instrutores com ampla experiência no assunto!
        </p>
        <p className="article-paragraph">
          Quer acompanhar mais conteúdos como este? Acompanhe nosso blog e descubra como podemos transformar o presente para garantir um futuro mais verde.
        </p>
        <p className="article-paragraph">
          #Biolink #BlogBiolink #Sustentabilidade #ConsultoriaAmbiental #MeioAmbiente
        </p>
      </section>

      <div className="back-button-container">
        <button onClick={handleGoBack} className="back-button">
          <i className="fas fa-arrow-left"></i>
          Outros artigos
        </button>
      </div>

      <section
        className="footer"
        style={{
          background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
        }}
      >
        <div className="box-container">
          <div className="box">
            <h3>Navegue</h3>
            <a href="#home"><i className="fas fa-chevron-right"></i> Início</a>
            <a href="#about"><i className="fas fa-chevron-right"></i> Sobre</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Serviços</a>
            <a href="#doctors"><i className="fas fa-chevron-right"></i> Equipe</a>
            <a href="#book"><i className="fas fa-chevron-right"></i> Iniciar conversa</a>
            <a href="#review"><i className="fas fa-chevron-right"></i> Avaliações</a>
            <a href="#blogs"><i className="fas fa-chevron-right"></i> Blog</a>
          </div>

          <div className="box">
            <h3>Nossos serviços</h3>
            <a href="#services"><i className="fas fa-chevron-right"></i> Licenciamento Ambiental e Regularização</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Flora</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Fauna</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Drones e Geoprocessamento</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Treinamentos e Capacitação</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Capex Opex</a>
          </div>

          <div className="box">
            <h3>Contato</h3>
            <a href="https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              <i className="fas fa-phone"></i> (34) 9 9920-3789
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              <i className="fas fa-phone"></i> (11) 9 8632-1639
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br?subject=Assunto%20do%20E-mail&body=Mensagem%20inicial">
              <i className="fas fa-envelope"></i> emerson@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais
            </a>
          </div>

          <div className="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.instagram.com/biolink_ambiental/">
              <i className="fab fa-instagram"></i> Instagram
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              <i className="fab fa-linkedin"></i> LinkedIn
            </a>
          </div>
        </div>

        <div className="credit">
          Criado por <span><a href="">Biolink</a></span> | ©Todos os direitos reservados.
        </div>
      </section>
    </div>
  );
};

export default ArticlePage;